export default "__VITE_ASSET__DM4j35eg__"